import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useForm } from 'react-hook-form';

import FormContext from './context';

const FormContextProvider = ({ children }) => {
  const {
    reset,
    register,
    setValue,
    handleSubmit,
    control,
    formState,
    trigger,
    getValues,
    unregister,
    watch,
    setError,
    clearErrors,
  } = useForm();

  const formValue = useMemo(() => ({
    formErrors: formState.errors,
    formControl: control,

    formReset: reset,
    formRegister: register,
    formSubmit: handleSubmit,
    formSetValue: setValue,
    formTrigger: trigger,
    formGetValues: getValues,
    formUnregister: unregister,
    formWatch: watch,
    formSetError: setError,
    formClearErrors: clearErrors,
  }), [formState, control, register]);

  return (
    <FormContext.Provider value={formValue}>
      {children}
    </FormContext.Provider>
  );
};

FormContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const withFormProvider = (Component) => function sonComponent(props) {
  return (
    <FormContextProvider>
      <Component {...props} />
    </FormContextProvider>
  );
};

export default FormContextProvider;
